<template>
    <div>

      <v-text-field
        v-if="!hidesearch"
        v-model="search"
        append-icon="mdi-magnify"
        label="rechercher dans le tableau"
        single-line
        hide-details
      ></v-text-field>

    <v-data-table
        :headers="head"
        :mobile-breakpoint="helpHeaders.length ? 0 : undefined"
        :items="thisItems"
        :show-select="showselect"
        :single-select="false"
        v-model="selectedItem"
        :search="search"
        :item-key="keyRow"
        @click:row="clickRow"
        :hide-default-footer="hideDefaultFooter"
        :disable-pagination="hideDefaultFooter"
        class="row-pointer"
    >

      <template v-for="header in helpHeaders" v-slot:[`header.${header.value}`]>
        <span :key="header.value" class="simple-table-help-label">
          {{ header.text }}
          <FieldHelp :help="header.help" :label="header.text" :field-id="header.fieldId" :modal-key="modalKey" />
        </span>
      </template>

      <template v-slot:body="props" v-if="isDraggable">
        <draggable
          v-model="props.items"
          tag="tbody"
          handle=".handle"
          @change=changeOrder(props)
        >
          <tr
            v-for="(ligne, i) in props.items" :key="i"
          >

            <td>
                <v-icon class="handle" style="cursor:grab;">mdi-arrow-up-down</v-icon>
                {{i+1}}
            </td>
            <template v-for="(val, i2) in head" >
            <td :key="i2" v-if="val.value!='action' && val.value!='orderTable'"> {{ ligne[val.value] }}</td>
            </template>

            <td v-if="isDraggable">
            <v-icon small v-for="(act,ind) in Edit" :key="ind"               
                class="mr-2"
                @click="act.action(ligne)"
            >
                {{act.icon}}
            </v-icon>
            </td> 

          </tr>
        </draggable>
      </template>

      <template v-slot:[`item.action`]="{ item }" v-if="!isDraggable">
            <v-icon small v-for="(v,i) in Edit" :key="i"               
                class="mr-2"
                @click="getAction(v,item)"
            >
                {{v.icon}} 
            </v-icon>

        </template>

    </v-data-table>

</div>
</template>


<script>
import FieldHelp from '@/components/fields/FieldHelp.vue'
import { normalizeFieldHelp } from '@/components/fields/helpContent'

export default {
    name : 'SimpleTable',
    props : ['Headers','datas','editTable','del','selected','disabled','keyRow','isDraggable','hidefooter','hidesearch','item','modalKey'],

    components : {
        FieldHelp,
        draggable    : () => import('vuedraggable'),
    },
        data: function() {
            return { 

                head : this.Headers,
                data : [],
                Delete : {icon:'mdi-delete',action:this.deleteItem},
                Edit : [],
                showselect : false,
                selectedItem : [],
                hideDefaultFooter : true,
                search : ''

            }
        },

watch : {

    datas() { 
        this.getDatas()
    },

    selectedItem(val) {

        var returnSelect = []
        if(val.length>0) {
            val.forEach((v) => {
                returnSelect.push(v[this.keyRow])
            })
        } 
        this.$emit('getselected',returnSelect);
    },
/*
    editTable() {
        this.Edit = []
        this.PutActionRow()
    }, */

},
computed: {
    helpHeaders() {
      return this.head.filter(header => normalizeFieldHelp(header.help).hasContent)
    },
    thisItems() {
        //permet de rendre non selectable les array ou la clé isSelectable = false
      return this.data.map(x => ({ ...x, isSelectable: x.isSelectable }));
    }
  },

        methods : {

            clickRow(line) {
                this.$emit('clickRow',line);
            },


            //pour chaque action on enleve le isSelectable et ne garder que l'essentiel
            getAction(v,item) {
                delete item['isSelectable'];
                v.action(item)
            },

            constructHeader() {

                this.head = this.Headers
                if(this.isDraggable) this.head.unshift({text:'ordre',value:'orderTable'})

            },

            changeOrder(props) {
                this.data = props.items
                this.$emit('recepVal',this.data);

            },

            PutActionRow() {

                if(Array.isArray(this.editTable)) {
                    if(!this.head.find(x => x.value == "action")) this.head.push({text:'action',value:'action',sortable:false})
                    this.editTable.forEach((v) => {
                        this.Edit.push(v)
                    })
                }
                
                if(this.del===true) this.Edit.push(this.Delete); 
            },

            getDatas() {

                this.data = []
                if(this.datas)
                this.datas.forEach((ligne) => {
                    this.data.push(ligne)                                
              
                })

            },

            deleteItem(item) {
                console.log(this.data,item,this.data.indexOf(item))
                if(confirm('Vous allez supprimer cette ligne, Etes-vous sur ?')) {
                const index = this.data.findIndex(i => JSON.stringify(i) === JSON.stringify(item));
                if (index !== -1) {
                    this.data.splice(index, 1);
                    // Émettre l'event avec le nouvel array
                    this.$emit('recepVal', this.data);
                }
                }
            }, 

 
            select : function() {
                if(this.selected && this.data.length>0) {

                    this.selected.forEach((id) => {

                        let result = this.data.find(el => el.id === id)

                        if(result) this.selectedItem.push(result)
                    })
                }

            }
        },




        mounted() {     
            this.PutActionRow()
            this.constructHeader()
            this.getDatas()
            if(this.selected) this.showselect = true

            if(this.hidefooter != undefined) this.hideDefaultFooter = this.hidefooter

            this.select();
     

        }


}

</script>

<style scoped>
.simple-table-help-label { display: inline-flex; align-items: center; gap: 4px; }
</style>
